module.exports = __webpack_public_path__ + "fonts/Montserrat-BoldItalic.9d216a71.ttf";